<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ 'Pedidos archivados' }}</template>
      </breadcrumb>

      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
      />

      <div class="col-md-12" v-if="respuesta">
        <template v-if="listaPedidosArchivados.length > 0 || isSearch || (listaPedidosArchivados <= 0 && tipo != 0)">
          <div class="row justify-content-between div-export">
            <div class="col-md-6">
              <!--<el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a @click="exportForm('Excel','Detalles')">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>

                  <!-- Funciona pero ahora esta en el informe de facturas -->
                  <!--<a @click="exportForm('Excel','Completo')">
                    <el-dropdown-item class="text-success">
                      <strong>
                        <i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcelDeTodosLosTickets") }}</strong
                      >
                    </el-dropdown-item>
                  </a>

                </el-dropdown-menu>
              </el-dropdown>-->
              <div class="mt-2">
                <el-radio-group v-model="tipo">
                  <el-radio :label="0">{{$t('todos')}}</el-radio>
                  <el-radio :label="'R'">{{$t('recoger')}}</el-radio>
                  <el-radio :label="'D'">{{$t('domicilio')}}</el-radio>
                  <el-radio :label="'M'">{{$t('mesa')}}</el-radio>
                </el-radio-group>
              </div>
            </div>
           
            <div class="input-group col-md-6">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('buscarPedidoPorCliente')"
                v-model="searchQuery"
                @keyup.enter.prevent="searchPedidosArchivados"
              />
              <div class="input-group-append">
                <button style="margin-bottom:0px"
                  @click="searchPedidosArchivados()"
                  class="btn btn-secondary"
                  type="button"
                >
                  <i class="fa fa-search"></i>
                </button>
                <button style="margin-bottom:0px"
                  @click="getPedidosArchivados(), searchQuery=''"
                  class="btn btn-secondary"
                  type="button"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <div
            v-if="listaPedidosArchivados.length > 0"
            class="table-responsive"
            style="overflow: auto"
          >
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th style="width: 10%;">
                    <span>
                      {{ $t("fecha") }}
                    </span>
                  </th>
                  <th v-if="estadio">
                    <span>
                      {{ $t('tpv')}}
                    </span>
                  </th>
                  <th style="width: 15%;">
                    <span>
                      {{ $t("cliente") }}
                    </span>
                  </th>
                  <th>
                    <span
                      >
                      {{ $t("tipo") }}
                    </span>
                  </th>
                  <th v-if="listaPedidosArchivados.some(pedido => pedido.tipo == 'Mesa')">
                    <span>
                      {{ $t("numeroDeMesa") }}
                    </span>
                  </th>
                  <th>
                    <span
                      >
                      {{ $t("formaDePago") }}
                    </span>
                  </th>
                  <th>
                    <span
                      >
                      {{ $t("envioProgramado") }}
                    </span>
                  </th>
                  <th>
                    <span
                      >
                      {{ $t("tiempoEstimado") }}
                    </span><i v-tooltip.top="'Tiempo estimado que se le dio al cliente'" class="fa fa-question-circle"></i>
                  </th>
                  <th v-if="listaPedidosArchivados.some(pedido => pedido.sinqro != '')">
                    <span
                      >
                      {{ $t("agenciaSinqro") }}
                    </span>
                  </th>
                  <th>
                    <span
                      >
                      {{ $t("total") }}
                    </span>
                  </th>
                  <th width="5%">
                    <span
                      >
                      {{ $t("gastosEnvio") }}
                    </span>
                  </th>
                  <!-- añado esta columna comprobar si ordena bien-->
                  <th width="10%">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pedido) in listaPedidosArchivados" :key="pedido.id">
                  <td>
                    {{ pedido.fecha | parseDateMin}}
                  </td>
                  <td v-if="estadio">
                    {{ pedido.nombreTpv }}  
                  </td>
                  <td style="text-align: center;"><a style="color: #004050; font-weight: bold; cursor: pointer;" @click="showDetallesCliente(pedido)"><i class="fas fa-search"></i> {{ pedido.cliente }}</a></td>
                  <td>{{ pedido.tipo }}</td>
                  <td v-if="listaPedidosArchivados.some(pedido => pedido.tipo == 'Mesa')"><span v-if="pedido.numMesa != -1">{{ pedido.numMesa }}</span><span v-else>-</span></td>
                  <td>{{ pedido.formaPago }}</td>
                  <td><span v-if="pedido.envioProgramado != 0">{{ pedido.envioProgramado | parseDateMin }}</span><span v-else>No</span></td>
                  <td>{{ pedido.tiempoEstimado }}</td>
                  <td v-if="listaPedidosArchivados.some(pedido => pedido.sinqro != '')"><span v-if="pedido.sinqro != ''">{{ pedido.siqnro }}</span><span v-else>-</span></td>
                  <td>{{ pedido.total | currency}}</td>
                  <td>{{ pedido.gastosEnvio | currency}}</td>
                  <td align="center">
                    <div class="btn btn-primary btn-link" v-if="pedido.idHeader != 0">
                      <i
                        @click="showDesgloseIVA(pedido.idHeader)"
                        v-tooltip.top-center="$i18n.t('verDesgloseDeImpuestos')"
                        class="fa fa-info-circle"
                      ></i>
                    </div>
                    <div class="btn btn-primary btn-link">
                      <i
                        @click="showDetallesPedido(pedido)"
                        v-tooltip.top-center="$i18n.t('verDetalles')"
                        class="fa fa-eye text-primary"
                      ></i>
                    </div>
                    <!--<div class="btn btn-primary btn-link text-success">
                      <a :href="urlExportTicketExcel(pedido.id)">
                        <i
                          v-tooltip.top-center="$i18n.t('exportarExcel')"
                          class="fa fa-file-excel text-success"
                        ></i
                      ></a>
                    </div>
                    <div class="btn btn-primary btn-link text-danger">
                      <a :href="urlExportTicketPDF(pedido.id)">
                        <i
                          v-tooltip.top-center="$i18n.t('exportarPdf')"
                          class="fa fa-file-pdf text-danger"
                        ></i>
                      </a>
                    </div>-->
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr></tr>
              </tfoot>
            </table>
          </div>

          <div class="row overflow-auto">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalPags"
              :per-page="porPagina"
              :limit="7"
              last-number
            ></b-pagination>
          </div>

        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            No hay pedidos archivados en el rango seleccionado
          </div>
        </template>
      </div>
    </div>
    <modal
        :name="'detalles-cliente'"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ 'Detalles del cliente del pedido' }}</h4>
          </div>
          <div class="modal-body">
            <template v-if="detallePedido.tipo != 'Recoger'">
              <p><strong>{{ $t('direccion') }}:</strong>{{detallePedido.direccion}}</p>
              <p v-if="detallePedido.ciudad != ''"><strong>{{ $t('ciudad') }}:</strong> {{detallePedido.ciudad}}</p>
              <p v-if="detallePedido.cp != ''"><strong>{{ $t('codigoPostal' ) }}:</strong> {{detallePedido.cp}}</p>
            </template>
            <p v-if="detallePedido.telefono != ''"><strong>{{ $t('telefono') }}:</strong> {{detallePedido.telefono}}</p>
            <p v-if="detallePedido.email != ''"><strong>{{ $t('email') }}:</strong> {{detallePedido.email}}</p>
            <p v-if="detallePedido.observacion != ''"><strong>{{ $t('observaciones') }}:</strong> {{detallePedido.observacion}}</p>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-default"
              @click="
                  $modal.hide('detalles-cliente'); detallePedido = {};
              "
            >
              <i class="fa fa-times-circle"></i> {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </modal>
    <modal
        :name="'detalles-pedido'"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("detallesDelPedido") }}</h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="margin-top: 10px">
              <table class="table  table-striped">
                <thead>
                  <tr>
                    <th>{{ $t("producto") }}</th>
                    <th>{{ $t("precioUd") }}</th>
                    <th>{{ $t("cantidad") }}</th>
                    <th>{{ $t("total") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="det in detallePedido.detalles">
                    <tr :key="det.id">
                      <td>
                        {{ det.nombreProducto + " " + det.namePrice }}
                        <template v-if="det.nombreCatego"
                          >({{ det.nombreCatego }})</template
                        >
                      </td>
                      <td align="right">{{ det.price | currency }}</td>
                      <td align="right">{{ det.units }}</td>
                      <td align="right">{{ det.amount | currency }}</td>
                    </tr>
                    <tr v-for="(sub, index) in det.subproducts" :key="sub.id + '-' + index">
                      <td align="left" style="padding-left: 15px">
                        > {{ sub.name }} -
                        <template v-if="sub.tipo === 'O'">{{
                          $t("opcional")
                        }}</template
                        ><template v-else-if="sub.tipo === 'E'">{{
                          $t("extra")
                        }}</template
                        ><template v-else>{{ $t("base") }}</template>
                        <template v-if="sub.free"
                          >({{ $t("gratis") }})</template
                        >
                      </td>
                      <td align="right">
                        {{ !sub.free ? sub.variacion : 0 | currency }}
                      </td>
                      <td align="right">{{ sub.cantidad }}</td>
                      <td align="right">
                        <template v-if="!sub.free">{{
                          (sub.cantidad * sub.variacion) | currency
                        }}</template>
                        <template v-else>{{ 0 | currency }}</template>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="detallePedido.importeGastosEnvio > 0">
                    <td colspan="3">{{ $t("gastosDeEnvio") }}</td>
                    <td align="right">
                      {{ detallePedido.importeGastosEnvio | currency }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="3">
                      <strong>{{ $t("total") }}</strong>
                    </td>
                    <td align="right">{{ detallePedido.total | currency }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-default"
              @click="
                  $modal.hide('detalles-pedido'); detallePedido = {};
              "
            >
              <i class="fa fa-times-circle"></i> {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </modal>
    
    <modal
      name="desglose-iva"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("desgloseDeImpuestos") }}</h4>
        </div>
        <div class="modal-body">
          <div
            v-if="listDesgloseIVA.length > 0"
            class="table-responsive"
            style="overflow: auto"
          >
            <table class="table table-bordered table-striped ">
              <thead class="thead-dark">
                <tr>
                  <th>{{ $t("tipoIva") }}</th>
                  <th>{{ $t("base") }}</th>
                  <th>{{ $t("impuesto") }}</th>
                  <th>{{ $t("importe") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ref, index) in listDesgloseIVA" :key="ref.id + '-' + index">
                  <td>{{ ref.vatType }} %</td>
                  <td>{{ ref.base | currency }}</td>
                  <td>{{ ref.valor | currency }}</td>
                  <td align="right">{{ ref.amount | currency }}</td>
                </tr>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}:</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td align="right">
                    <strong>{{ totalDesglose | currency }}</strong>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr></tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="$modal.hide('desglose-iva'); listDesgloseIVA = [];">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>

    <!--<modal
      name="desglose-ticket-modal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            {{ $t("desgloseDelTicket") }} {{ nameTickets }}
          </h4>
        </div>
        <div class="modal-body">
          <ticket :ticket="listDesgloseTicket"></ticket>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>-->
  </div>
</template>
<script>
import {
  DatePicker,
  Select,
  Radio,
  RadioGroup,
  Option,
  Dropdown,
  DropdownItem,
  Loading,
  DropdownMenu,
  Button,
   Switch,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Ticket from "../../../Widgets/Ticket.vue";
import { mapState } from 'vuex';
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", "Pedidos archivados");
    this.getBusiness();

    if (this.sectores && this.$cookies.isKey("sectores")) {
      this.estadio = true;
    }

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    ticket: Ticket,
    Breadcrumb,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],

      idBusiness: this.$route.params.idBusiness,

      idTpv: 0,
      listTpv: [],
      searchQuery: this.$route.params.query,
      searchQueryLog: '',
      isSearch: this.$route.params.isSearch ? this.$route.params.isSearch : false,
      listaPedidosArchivados: [],
      tipo: 0,
      tipoAnterior: 0,
      //PAGINACION
      pag: this.$route.params.pag ? this.$route.params.pag : 1,
      totalPags: 0,
      porPagina: 0,
      currentPage: this.$route.params.pag ? this.$route.params.pag : 1,

      //ORDENAR

      respuesta: true,
      detallePedido: {},
      listDesgloseIVA: [],
      estadio: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.pag) {
        this.pag = to.params.pag;
        if(this.isSearch) {
          this.searchPedidosArchivados();
        } else {
          this.getPedidosArchivados();
        }
      } else if (to.params.query) {
        this.query = to.params.query;
        if(this.isSearch) {
          this.searchPedidosArchivados();
        } else {
          this.getPedidosArchivados();
        }
      }
    },
    tipo() {
      if(this.isSearch) {
        this.searchPedidosArchivados();
      } else {
        this.getPedidosArchivados();
      }  
    },
    currentPage() {
      this.$router.push({
        name: 'pedidos-archivados', 
        params: {
          pag: this.currentPage
        },
      });
    }
  },
  computed: {
    ...mapState(["listaSectores", "sectores"]),
    totalDesglose() {
      let total = 0;

      this.listDesgloseIVA.forEach(function(x) {
        total += x.amount;
      });

      return total;
    },
    urlExportExcelconDetalles() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportTickets/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&conDetalles=" +
        1+
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcelCompleto() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportTickets/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&conDetalles=" +
        0+
        "&completo=" +
        1+
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

    nextPag() {
      let nextPag = parseInt(this.pag) + 1;
      return nextPag;
    },
  },
  methods: {
    showDetallesCliente(pedido) {
      this.detallePedido = pedido;
      this.$modal.show("detalles-cliente");
    },
    showDetallesPedido(pedido) {
      this.detallePedido = pedido;
      this.$modal.show("detalles-pedido");
    },
    showDesgloseIVA(idHeader) {
      this.getDesgloseIVA(idHeader);

      this.$modal.show("desglose-iva");
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getTpv();

        })
        .catch(function(error) {
          console.log(error);
        });
    },
    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
        this.idTpv = listTpv[0].id;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.list = [];
      this.cambioTpv();
    },
    emitirConsulta() {
      if(this.isSearch) {
        this.searchPedidosArchivados();
      } else {
        this.getPedidosArchivados();
      }
    },
    cambioTpv(idTpvData, filtrar) {
      if (idTpvData) {
        this.idTpv = idTpvData;
      }
      
      this.isSearch = false;
      this.searchQuery = '';
      this.emitirConsulta();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;

            vm.idTpv = vm.listTpv[0].id;
            vm.getPedidosArchivados();

          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },

    getPedidosArchivados() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom)
          .startOf("day")
          .unix();
        let secondsHasta = moment(this.dateto)
          .endOf("day")
          .unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          this.loading = Loading.service({ text: "Cargando..." });

          const controller = "getPedidosArchivados";

          if(this.isSearch || this.tipo != this.tipoAnterior) {
            this.pag = 1;
            this.currentPage = 1;
          }
          this.isSearch = false;
          this.searchQuery = '';

          var config = {
            params: {
              idTpv: this.idTpv,
              tipo: this.tipo,
              pag: this.pag,
              from: moment(this.datefrom)
                .startOf("day")
                .unix(),
              to: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
            .then(function(response) {
              if (response.data.response && response.data.rangoMayor != true) {
                vm.respuesta = true;

                vm.tipoAnterior = vm.tipo;
                vm.listaPedidosArchivados = response.data.result.pedidosArchivados;
                vm.pag = response.data.result.pag;
                vm.totalPags = response.data.result.totalPags;
                vm.porPagina = 1;
                
              }else if (response.data.response == false && response.data.rangoMayor == true) {
                    swal({
                      title: "Lo sentimos",
                      text: response.data.result,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "info",
                    });
                    vm.respuesta = false;
              }  else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
    searchPedidosArchivados() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom)
          .startOf("day")
          .unix();
        let secondsHasta = moment(this.dateto)
          .endOf("day")
          .unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });

          const controller = this.searchQuery
            ? "searchPedidosArchivados/" + this.searchQuery
            : "getPedidosArchivados";

          if(!this.isSearch) {
            this.pag = 1;
          }

          if(this.searchQueryLog != this.searchQuery) {
            this.pag=1;
          }

          if (this.tipo != this.tipoAnterior) {
            this.pag = 1;
            this.currentPage = 1;
          }

          this.searchQueryLog = this.searchQuery;

          var config = {
            params: {
              idTpv: this.idTpv,
              tipo: this.tipo,
              pag: this.pag,
              from: moment(this.datefrom)
                .startOf("day")
                .unix(),
              to: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
            .then(function(response) {
              if (response.data.response) {

                vm.tipoAnterior = vm.tipo;
                vm.listaPedidosArchivados = response.data.result.pedidosArchivados;
                vm.pag = response.data.result.pag;
                vm.totalPags = response.data.result.totalPags;
                vm.porPagina = 1;

                vm.isSearch = true;
                
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },

    urlExportTicketPDF(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportTicket/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketExcel(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportTicket/Excel?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    getDesgloseIVA(idHeader) {
      this.loading = Loading.service({ text: "Cargando..." });

      const controller = "getTicketsDetailsById";

      var config = {
        params: {
          idBusiness: this.idBusiness,
          idHeader: idHeader,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "sales/" + controller, config)
        .then(function(response) {
          if (response.data.response) {
            vm.listDesgloseIVA = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
        
      
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

.sunday {
  color: rgb(128, 0, 0);
}

.fridaySaturday {
  color: rgb(0, 128, 64);
}

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Pedidos/PedidosArchivados.vue